// tslint:disable:no-null-keyword typedef
import { LocalStorageService, SessionStorageService } from './web-storage';
 
export class AbstractService {
  protected sessionStorageKey: string;
  //protected localStorageKey: string;
  protected sessionStorageService: SessionStorageService;
  //protected localStorageService: LocalStorageService;

  // handleError<T>(result: T) {
  //   return (error: any): Observable<T> => Observable.of(result);
  // }

  protected getDataFromSessionStorage(
    convertToJSON = true,
    key: string = this.sessionStorageKey
  ): any {
    if (this.sessionStorageService && key) {
      return this.sessionStorageService.getItem(key, convertToJSON);
    }

    return null;
  }

  protected setDataToSessionStorage(
    data: any,
    convertToJSON = true,
    key: string = this.sessionStorageKey
  ): void {
    if (this.sessionStorageService && key) {
      this.sessionStorageService.setItem(key, data, convertToJSON);
    }
  }

  // getDataFromLocalStorage(
  //   convertToJSON = true,
  //   key: string = this.localStorageKey
  // ): any {
  //   if (this.localStorageService && key) {
  //     return this.localStorageService.getItem(key, convertToJSON);
  //   }

  //   return null;
  // }

  // setDataToLocalStorage(
  //   data: any,
  //   convertToJSON = true,
  //   key: string = this.localStorageKey
  // ): void {
  //   if (this.localStorageService && key) {
  //     this.localStorageService.setItem(key, data, convertToJSON);
  //   }
  // }

  // prepareUrl(rawUrl, replacements): string {
  //   let newUrl = rawUrl;
  //   for (const key in replacements) {
  //     if (replacements.hasOwnProperty(key)) {
  //       newUrl = newUrl.replace(`\$\{${key}\}`, replacements[key]);
  //     }
  //   }

  //   return newUrl;
  // }

  // // use when making wcm connect calls
  // buildRequestContentTypeHeaderAsForm(): any {
  //   return new HttpHeaders().set(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded"
  //   );
  // }

  // buildRequestContentTypeHeaderAsJSON(): any {
  //   return new HttpHeaders().set("Content-Type", "application/json");
  // }

  // cloneData(sourceData: any): any {
  //   return JSON.parse(JSON.stringify(sourceData));
  // }
}
